import React from 'react'
import { Col, Card, CardBody, Row, Badge, } from 'reactstrap'
import { Link, } from 'react-router-dom'
import { AssessDashCircle, AssessSkillBar, AssessSubtestInfoBlock, AssessDashCircleSVG } from '../Assessment'
import computeSummaryNodeData from '../../helpers/assessment/computeSummaryNodeData'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'
import uuid from 'uuid/v1'

/* AssessDashTestSummary

  <AssessDashSubtestResults
    sub={props.sub}
    title={props.title}
    subtest={props.subtest}
    byNodeScoring={byNodeScoring}
    bySubtestScoring={bySubtestScoring}
    nodes={props.nodes}
    userAssessmentId={props.userAssessmentId}
    groupUAId={props.groupUAId}
    isStudent={props.isStudent}
  />

*/
export default function byNodeScoring(props) {
  // Compute the circle based on the scale score
  const colorsBySubtestType = {
    English: 'purple',
    Math: '#f86c6b',
    Reading: '#20a8d8',
    Science: '#4dbd74',
  }

  const fallbackColor = '#ffc107'

  const themeColors = {
    English: 'english',
    Math: 'danger',
    Reading: 'primary',
    Science: 'success',
  }

  const fallbackThemeColor = 'warning'

  let labels = ['', '']
  props.subtest ? labels = [props.subtest.displayName, 'Missed'] : null
  let scaleScore ,comparescaleScore
  let data = [1, 1]
  let dataCompare = [1, 1]
  if (props.subtest && props.bySubtestScoring) {
    if (props.userAssessmentId) {
     
      // scaleScore = props.subtest.rawToScaleScoring[props.bySubtestScoring.raw]
      scaleScore = props.bySubtestScoring.scale
      if(props.selectedStudent===""  && typeof scaleScore!=="undefined" &&  props.isStudent===false ) {
        if(typeof scaleScore==="string" )
        {
          scaleScore = parseFloat(scaleScore);
        }
        scaleScore = scaleScore.toFixed(1);
      }
      data = [scaleScore, 36 - scaleScore]
    } else if (props.groupUAId) {
      scaleScore = Math.round(parseFloat(props.bySubtestScoring.scale) * 10) / 10
      if(props.selectedStudent==="" && typeof scaleScore !== 'undefined'){
        scaleScore = (Math.round(parseFloat(props.bySubtestScoring.scale) * 10) / 10).toFixed(1);
      }
      data = [scaleScore, 36 - scaleScore]
    }
  }

  //--------------------
  if (props.subtest && props.scoringCompare) {
    if (props.scoringCompare) {
      // scaleScore = props.subtest.rawToScaleScoring[props.bySubtestScoring.raw]
      props.bySubtestScoringComparing ? (comparescaleScore = props.bySubtestScoringComparing.scale): 0
      if(props.selectedStudent===""  && typeof comparescaleScore!=="undefined" &&  props.isStudent===false ) {
        if(typeof comparescaleScore==="string" )
        {
          comparescaleScore = parseFloat(comparescaleScore);
        }
        comparescaleScore = comparescaleScore.toFixed(1);
      }
      dataCompare = [comparescaleScore, 36 - comparescaleScore]
    } else if (props.groupUAId) {
      comparescaleScore = Math.round(parseFloat(props.comparebySubtestScoring.scale) * 10) / 10
      if(props.selectedStudent==="" && typeof comparescaleScore !== 'undefined'){
        comparescaleScore = (Math.round(parseFloat(props.comparebySubtestScoring.scale) * 10) / 10).toFixed(1);
      }
      dataCompare = [scaleScore, 36 - scaleScore]
    }
  }


  let backgroundColor = ['#4d4d4d', '#4d4d4d']
  if (props.subtest && props.bySubtestScoring) {
    if (colorsBySubtestType[props.subtest.displayName]) {
      backgroundColor = [
        colorsBySubtestType[props.subtest.displayName],
        '#4d4d4d',
      ]
    } else {
      backgroundColor = [fallbackColor, '#4d4d4d']
    }
  }

  const hoverBackgroundColor = backgroundColor


  // Compute the nodes to show and what to show. Create a SkillBar object for each.

  let linkToReview = ''
  let linkToReport = ''
  let reportQuery = ''
  if (!props.isStudent) {
    reportQuery = `?g=true&a=${props.assessmentId}`
  }

  // if we are viewing a userAssessment, but from a group view, we need to use groupUAId/subtestId?query with studentId (not userAssessment)
  // need to know
  if (props.userAssessmentId && props.subtest && props.selectedGroupUA) {
    reportQuery = `?g=true&a=${props.assessmentId}&s=${props.selectedStudent}`
    linkToReview = `/assessment/testing/${props.selectedGroupUA}/${props.subtest.setId}${reportQuery}${reportQuery ? '&' : '?'}item=overview`
    linkToReport = `/assessment/reports/${props.selectedGroupUA}/${props.subtest.setId}${reportQuery}`
  } else if (props.userAssessmentId && props.subtest) {
    linkToReview = `/assessment/testing/${props.userAssessmentId}/${props.subtest.setId}${reportQuery}${reportQuery ? '&' : '?'}item=overview`
    linkToReport = `/assessment/reports/${props.userAssessmentId}/${props.subtest.setId}${reportQuery}`
  } else if (props.groupUAId && props.subtest) {
    linkToReview = `/assessment/testing/${props.groupUAId}/${props.subtest.setId}${reportQuery}${reportQuery ? '&' : '?'}item=overview`
    linkToReport = `/assessment/reports/${props.groupUAId}/${props.subtest.setId}${reportQuery}`
  }
  let skillBars = []
  if (props.nodes && props.byNodeScoring && props.subtest) {
    // pull the first level nodes
    let combineData ;
    const nodeScoreData = computeSummaryNodeData(props.nodes, props.byNodeScoring, props.subtest)
    const nodeScoreDataCompare =  props.byNodeScoringCompare && computeSummaryNodeData(props.nodes, props.byNodeScoringCompare, props.subtest) 
    if(nodeScoreDataCompare !== null &&  nodeScoreDataCompare && nodeScoreDataCompare.length >0){
      nodeScoreDataCompare.map((node,i)=>{
        nodeScoreData[i].raw1 = node.raw
        nodeScoreData[i].possibleCompare = node.possible
      })
    }
    if(!nodeScoreDataCompare){
      combineData = nodeScoreData
    }else{
      combineData = [...nodeScoreData , ...nodeScoreDataCompare]
    }

if (nodeScoreData) {
  const sortedNodeScoreData = sortByPropText(nodeScoreData, 'name')

      sortedNodeScoreData.forEach((nodeScore, i) => {
        if (nodeScore.possible > 0) {
          skillBars.push(
            <Link to={linkToReport} style={{"textDecoration":"none"}} key={uuid()}>
              <AssessSkillBar
                nodeName={nodeScore.name}
                raw={nodeScore.raw}
                possible={nodeScore.possible}
                percent={Math.round(nodeScore.raw / nodeScore.possible * 100)}
                percentCompare = {Math.round(nodeScore.raw1 / nodeScore.possibleCompare * 100)}
                color={themeColors[props.subtest.displayName] ? themeColors[props.subtest.displayName] : fallbackThemeColor}
                testName={props.title}
                key={`skillBar${nodeScore.name}`}
                isStudent={(props.isStudent || props.selectedStudent!=="") ? true : false}
                linkToReport = {linkToReport}
                isCompare = {props.isCompare}
              />
            </Link>
          )
        }
      })
    }
    
  }



  let skillBarGroup = (
    <ul className='horizontal-bars type-2'>
      {skillBars.length > 0 ? skillBars : <li></li>}
    </ul>
  )

  if (!props.isStudent && !skillBars.length) {
    skillBarGroup = (
      <p>No students in this group have completed this test yet, so no skill data is available.</p>
    )
  }


  let assessSubtestInfoBlock = null
  if (props.sub) {
    let status = 'start'
    assessSubtestInfoBlock = (
      <AssessSubtestInfoBlock
        status={status}   // complete, resume, or start
        correct={props.bySubtestScoring ? props.bySubtestScoring.raw : 0}
        possible={props.bySubtestScoring ? props.bySubtestScoring.possible : 0}
        skillReportLink={linkToReport}
        itemReportLink={linkToReview}
        isStudent={(props.isStudent || props.selectedStudent
          ) ? true : false}
      />
    )
  }

  return (
    // SUB CARD WHEN SECTION IS COMPLETED
    <Card className='assessment-overview-by-subject rounded-top'>
      <Row className='assessment-overview-by-subject__title-container rounded-top' noGutters>
        <Col xs='12'>
          {props.sub
            ? <h3 className='title'><Link className='m2link-black link' to={linkToReport}>{props.title}</Link></h3>
            : <h2 className='title'>{props.title}</h2>}
        </Col>
      </Row>
      <CardBody>
        <Row>
          <Col xs='12'>
            <AssessDashCircle
              labels={labels}
              data={data}
              compareScore =  {comparescaleScore ?( (comparescaleScore!==0)?comparescaleScore:0):0}
              backgroundColor={backgroundColor}
              hoverBackgroundColor={hoverBackgroundColor}
              score={(scaleScore!==0)?scaleScore:0}
              subject={props.subtest.displayName}
              isAssessmentInitializing={props.isAssessmentInitializing}
              subtestAssessCircle={true}
              skillReportLink={linkToReport}
              itemReportLink={linkToReview}
              props = {props}
              sub = {props.sub}
              title = {props.title}
              isCompare = {props.isCompare}
              test1 = {props.test1}
              test2 = {props.test2}
              isSwap = {props.isSwap}
            />

          
          </Col>
          <Col xs='12'>
            {assessSubtestInfoBlock}
            {skillBarGroup}
            
          </Col>
        </Row>
      </CardBody>
    </Card >
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDashSubtestResults.js